import { usePageStore } from '@/store/usePageStore';
import { isDesktopScreen } from './sizes';

export const blockPageScroll = (): void => {
  if (typeof window === 'undefined') return;
  const scrollbarWidth =
    window.innerWidth - document.documentElement.clientWidth;

  usePageStore.getState().setIsScrollBlocked(true);

  if (isDesktopScreen()) {
    document.documentElement.style.paddingRight = `${scrollbarWidth}px`;
  }
};

export const allowPageScroll = (): void => {
  if (typeof window === 'undefined') return;
  usePageStore.getState().setIsScrollBlocked(false);

  document.documentElement.style.paddingRight = '';
};
